import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Dialog, DialogTitle, DialogContent, IconButton, ToggleButtonGroup, ToggleButton, Box, Grid, Divider, Card, CardMedia,
  CardContent,
  Typography, Avatar, Button, Checkbox, FormControlLabel,
  TextField, Select, MenuItem, InputLabel, FormControl,DialogActions
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import ViewQuiltIcon from "@mui/icons-material/ViewQuilt";
import Masonry from "react-masonry-css";
import { getModels, getGenereatedImages, generateEventImages, TrainingInfo, ModelDetails, enhancePromptVariation, enhancePrompt } from "../../services/apiService";
import './Popup.css';
import CollectionsIcon from '@mui/icons-material/Collections';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import promptMessage from "../../assets/promptMessage.png";
import  AspectRatioBox  from "../Reusable/AspectRatioDesign";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ReusableButton from "../Reusable/PrimaryButton/PrimaryButton";
import SecondaryButton from "../Reusable/SecondaryButton/SecondaryButton";
import PopupButton from "../Reusable/Popupbutton/PopupButton";
import { showToast } from "../Toast/CommonToast";
import {useShowcaseWebSocket} from "../../context/ShowcaseProvider";
import LoaderWithBackdrop from "../Loader/loader";
import { useCreditPoints } from "../../services/CreditPointsProvider";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import PlayCircleOutlinedIcon from '@mui/icons-material/PlayCircleOutlined';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';

interface ImageId {
  _id: string;
  url: string;
  caption: string;
}
interface GalleyPopupProps {
  open: boolean;
  onClose: () => void;
  selectionMode?: string
  setSelectionMode?: (mode: 'card' | 'image') => void;
 setSelectedImageId?: (image: ImageId | null) => void;
  selectedImageId?: string | ImageId | null;
  setVoiceDetails?: any;
  setVoiceType?:any
  voiceDetails?: any;
  setUserProfileIcon?: any;
}

const GalleyPopup: React.FC<GalleyPopupProps> = ({ open, onClose, selectionMode, setSelectionMode, setSelectedImageId, setVoiceDetails , setVoiceType, voiceDetails, setUserProfileIcon}) => {
  // Provide a default no-op function if setVoiceDetails or setVoiceType is not passed
  setVoiceDetails = setVoiceDetails || (() => {});
  setVoiceType = setVoiceType || (() => {});
  const location = useLocation();
  const [view, setView] = useState<'grid' | 'masonry'>('masonry');
  const userId = localStorage.getItem("userId") || "";
  const [models, setModels] = useState<any[]>([]);
  const filterType = [
    "Person",
    "AiInfluencer",
  ];
  const [selectedTypes, setSelectedTypes] = useState<string[]>([]);
  const [images, setImages] = useState<any[]>([]);
  const [aspectRatio, setAspectRatio] = useState<string>("portrait_16_9");
  const [prompt, setPrompt] = useState<string>("");
  const [promptMessageVisible, setPromptMessageVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
   const { responseData, reconnectWebSocket } = useShowcaseWebSocket();
   const { fetchCreditPoints } = useCreditPoints();
   const [trainingIds, setTrainingId] = useState<string | null>(null);
   const [path, setPath] = useState<string | null>(null);
  const [modeId, setModeId] = useState<string | null>(null);
  const [playingModelId, setPlayingModelId] = useState<string | null>(null);
  const audioRef = React.useRef<HTMLAudioElement | null>(null);
  const [waveformData, setWaveformData] = useState<number[]>([]);
  const [audioProgress, setAudioProgress] = useState<number>(0); // 0 to 1
  // Generate random waveform data for visual effect
  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (playingModelId) {
      interval = setInterval(() => {
        const data = Array.from({ length: 40 }, () => Math.max(20, Math.round(Math.random() * 80 + 20)));
        setWaveformData(data);
        // Update audio progress
        if (audioRef.current && audioRef.current.duration > 0) {
          setAudioProgress(audioRef.current.currentTime / audioRef.current.duration);
        }
      }, 100);
    } else {
      setWaveformData([]);
      setAudioProgress(0);
    }
    return () => clearInterval(interval);
  }, [playingModelId]);


    const handleAspectRatioChange = (event: any) => {
        setAspectRatio(event.target.value);
    };

    useEffect(() => {
       console.log("SocketResponse", responseData);
           if (responseData) {
               const responseArray = Array.isArray(responseData) ? responseData : [responseData];
               if (responseArray.length > 0) {
                   setImages((prev: any[]) => {
                       const safePrev = Array.isArray(prev) ? prev : [];
                       const allImages = [...responseArray, ...safePrev];
                       const uniqueImages = allImages.filter((img, index, arr) =>
                           arr.findIndex(item =>
                               (item._id && item._id === img._id) ||
                               (item.url && item.url === img.url)
                           ) === index
                       );
                       return uniqueImages;
                   });
               }
               fetchCreditPoints(userId);
           }
       }, [responseData, fetchCreditPoints, userId]);

  const fetchModels = React.useCallback(async () => {
    try {
      if (userId) {
        const data = await getModels(userId, false);
        setModels(data);
       
        setVoiceDetails(data.find((model: any) => model.voiceDetails) || null);
        setUserProfileIcon(false);
      }
    } catch (error) {
      console.error("Error fetching models", error);
    }
  }, [userId]);

  useEffect(() => {
    fetchModels();
  }, [userId, fetchModels]);



  const handleEventDetails = async (modelId: any) => {
    console.log("modelId", modelId);

    // Find the model in models list by _id
    const selectedModel = models.find((m: any) => m._id === modelId._id);
if (selectedModel && selectedModel.voiceDetails) {
  setVoiceDetails(selectedModel.voiceDetails);
   setVoiceType(selectedModel.type || '');
  console.log("voiceDetails found:", selectedModel.voiceDetails);
} else {
  setVoiceDetails(null);
  console.log("No voiceDetails for this model.");
}

    const fetchModelDetails: any = await ModelDetails(modelId?._id);
    setModeId(modelId);
    setTrainingId(fetchModelDetails?.data[0]?.trainingId);

    try {
      const eventDetails = await getGenereatedImages(userId, fetchModelDetails?.data[0]?.trainingId, false);
      console.log("eventDetails", eventDetails);
      if (eventDetails) {
        setImages(eventDetails?.data);
        setSelectionMode && setSelectionMode('image');
      }
    } catch (error) {
      console.error("Error fetching event details:", error);
    }
  }  

  const handleGenerateImages = async () => {
    if (!prompt) {
      showToast("Please enter a prompt to generate images.", "error");
      return;
    };
    setPromptMessageVisible(true);
  }
  const handleEnhancePrompt = async() => {
    if(prompt.trim().length === 0) {
      showToast("Please enter a prompt to enhance", "error");
      return;
    }
    try {
      const payload ={
        prompt: prompt,
      }
      const response = await enhancePrompt(payload);
      if(response.status === "success") {
        setPrompt(response.data);
        showToast(response.message, "success");
      } else {
        showToast(response.message, 'error');
      }
    } catch (error:any) {
      showToast(error?.message, 'error');
    }
  };
  
  const handleVariantPrompt = async() => {
    try {
      const payload ={
        prompt: prompt,
      }
      const response = await enhancePromptVariation(payload);
      if(response.status === "success") {
        setPrompt(response.data);
        showToast(response.message, "success");
      } else {
        showToast(response.message, 'error');
      }
    } catch (error:any) {
      showToast(error?.message, 'error');
    }
  };




   const getTrainingInfo = React.useCallback(async () => {
      try {
        if (trainingIds) {
          const data = await TrainingInfo(trainingIds);
          if (data.status === "success") {
            setPath(data.data.diffusersLoraFileUrl);
          }
        } else {
          console.error("Model ID is undefined");
        }
      } catch (err) {
        console.error("Error fetching models", err);
      }
    }, [trainingIds]);

      useEffect(()=>{
    getTrainingInfo();
  },[trainingIds, getTrainingInfo]);

  const handleConfirmImage = async () => {
    if(!userId || !prompt) return;
    reconnectWebSocket('6853fabf1c0892b44fc8be80');
     const generateData = {
            diffusersLoraFileUrl:  path ? path.trim() : '', 
            prompt,
            userId: userId,
            modelId: modeId || '',
            trainingId: trainingIds || "",
            imageSize: aspectRatio,
            numImages: 1,
            creditsPoint:25,
            eventId: '6853fabf1c0892b44fc8be80',
        };
        setLoading(true);
    try {
        const response = await generateEventImages(generateData);
        setLoading(false);
        if(response){
          setImages((prev: any[]) => [
  ...((response?.data?.imageGenerationId?.data && Array.isArray(response.data.imageGenerationId.data)) ? response.data.imageGenerationId.data : []),
  ...(Array.isArray(prev) ? prev : [])
]);
setPrompt("")
        }
      
    } catch (error) {
      setLoading(false);
      console.error("Error generating images:", error);
    }
  };
  const carToonpage = location.pathname.includes("cartoon");
  console.log("voiceDetails", voiceDetails)

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth className="PopupContainerGallery">
      {loading && <LoaderWithBackdrop open={loading} />}
      <DialogTitle className="gallery-header-title">
        <Box className="containerGallery" >
          <Box className="gallery-header">
            <CollectionsIcon />
            <Typography  className="gallerytitle">Select from Persona</Typography>
          </Box>
       
          <Box sx={{ display: 'flex'}}>
            {selectionMode === 'card' && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                {filterType.map((type) => (
                  <FormControlLabel
                    key={type}
                    control={
                      <Checkbox
                        checked={selectedTypes.includes(type)}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                          setSelectedTypes((prev) =>
                            checked ? [...prev, type] : prev.filter((t) => t !== type)
                          );
                        }}
                        className="radio-group"
                      />
                    }
                    label={type}
                  />
                ))}
              </Box>
            )}
            <IconButton onClick={()=>{
              setUserProfileIcon?.(true);
              onClose();
            }}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
        <Divider className="studioDivider" />


      </DialogTitle>
      {selectionMode === 'image' && (
        <DialogContent>
          <Box className="gallery-header gallery-title-container">
            <ArrowBackIosIcon
              className="back-icon"
              onClick={() => {
                setSelectionMode && setSelectionMode('card');
                setImages([]);
                setSelectedImageId && setSelectedImageId(null);
                setUserProfileIcon?.(true);
              }}
            />
            <Box >
              <Typography className="gallerytitle">Character Selection / Image Generation from Event</Typography>
            </Box>
          </Box>
          <Grid container spacing={2} className="gallery-content">
            <Grid item xs={12} md={4}>
              <Box className="promptcontainer">
                <Box className="promptDetails">
                  <Box className="gallery-header">
                    <img src={promptMessage} alt="Prompt" className="promptImage" />
                    <Typography variant="body1" className="uploadTexts">
                      Describe the character
                    </Typography>
                  </Box>
                   <Box className="promptImageContainer">
                            <ReusableButton
                            onClick={handleVariantPrompt}
                            disabled={!prompt}
                            icon={<AutoAwesomeIcon />}
                            >Variant with AI</ReusableButton>
                            <ReusableButton
                            onClick={handleEnhancePrompt}
                            disabled={!prompt}
                            icon={<AutoAwesomeIcon />}
                            >Enhance with AI</ReusableButton>
                          </Box>
                  <Box sx={{ mt: 2 }}>
                    <TextField
                      fullWidth
                      placeholder="Prompt the environment of the character"
                      value={prompt}
                     multiline rows={4}
                     maxRows={prompt ? 5 : 1}
                      variant="outlined"
                      className="textField"
                      onChange={(e) => setPrompt(e.target.value)}
                    />
                  </Box>
                  <Box sx={{ mt: 2 }}>
                       <FormControl variant="outlined" fullWidth className="selectField">
                                        <InputLabel>Aspect-ratio</InputLabel>
                                        <Select
                                            label="aspect-ratio"
                                            value={aspectRatio}
                                            onChange={handleAspectRatioChange}
                                            className='select'
                                            renderValue={(selected) => {
                                                let ratio = '';
                                                switch(selected) {
                                                  case 'square': ratio = '1:1'; break;
                                                  case 'portrait_4_3': ratio = '3:4'; break;
                                                  case 'portrait_16_9': ratio = '9:16'; break;
                                                  case 'landscape_4_3': ratio = '4:3'; break;
                                                  case 'landscape_16_9': ratio = '16:9'; break;
                                                  default: ratio = 'Select';
                                                }
                                                return (
                                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                   
                                                    {ratio}
                                                  </Box>
                                                );
                                            }}
                                        >
                                            <MenuItem value="">
                                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                  <Box sx={{ width: 16, height: 16, border: '2px solid #ccc', borderRadius: '2px' }} />
                                                  Select
                                                </Box>
                                              </Box>
                                            </MenuItem>
                                            <MenuItem value="square" className="selectBtn">
                                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                  <AspectRatioBox ratio="1:1" isSelected={aspectRatio === 'square'} />
                                                  1:1
                                                </Box>
                                                {aspectRatio === 'square' && <CheckCircleIcon color="success" fontSize="small" />}
                                              </Box>
                                            </MenuItem>
                                            <MenuItem value="portrait_4_3" className="selectBtn">
                                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                  <AspectRatioBox ratio="3:4" isSelected={aspectRatio === 'portrait_4_3'} />
                                                  3:4
                                                </Box>
                                                {aspectRatio === 'portrait_4_3' && <CheckCircleIcon color="success" fontSize="small" />}
                                              </Box>
                                            </MenuItem>
                                            <MenuItem value="portrait_16_9" className="selectBtn">
                                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                  <AspectRatioBox ratio="9:16" isSelected={aspectRatio === 'portrait_16_9'} />
                                                  9:16
                                                </Box>
                                                {aspectRatio === 'portrait_16_9' && <CheckCircleIcon color="success" fontSize="small" />}
                                              </Box>
                                            </MenuItem>
                                            <MenuItem value="landscape_4_3" className="selectBtn">
                                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                  <AspectRatioBox ratio="4:3" isSelected={aspectRatio === 'landscape_4_3'} />
                                                  4:3
                                                </Box>
                                                {aspectRatio === 'landscape_4_3' && <CheckCircleIcon color="success" fontSize="small" />}
                                              </Box>
                                            </MenuItem>
                                            <MenuItem value="landscape_16_9" className="selectBtn">
                                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                  <AspectRatioBox ratio="16:9" isSelected={aspectRatio === 'landscape_16_9'} />
                                                  16:9
                                                </Box>
                                                {aspectRatio === 'landscape_16_9' && <CheckCircleIcon color="success" fontSize="small" />}
                                              </Box>
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                  </Box>
                  <Box className="promptButton">
                    <ReusableButton onClick={handleGenerateImages}>Generate (25 Credits)</ReusableButton>
                  </Box>
                  {promptMessageVisible && (
                    <Dialog open={promptMessageVisible} onClose={() => setPromptMessageVisible(false)}>
                      <DialogTitle>Confirm Image Generation</DialogTitle>
                      <DialogContent>
                        <Typography>
                          Are you sure you want to generate an image? This will cost 25 credits.
                        </Typography>
                      </DialogContent>
                      <DialogActions>
                        <SecondaryButton onClick={() => setPromptMessageVisible(false)} color="secondary" variant="outlined">
                          Cancel
                        </SecondaryButton>
                        <PopupButton
                          onClick={() => {
                            setPromptMessageVisible(false);
                            handleConfirmImage()
                          }}
  
                        >
                          Confirm
                        </PopupButton>
                      </DialogActions>
                    </Dialog>
                  )}
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={8} >
              <Box>
                <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end' }}>
                  <ToggleButtonGroup
                    value={view}
                    exclusive
                    onChange={(_, val) => val && setView(val)}
                    size="small"
                  >
                    <ToggleButton value="grid" aria-label="Grid View">
                      <ViewModuleIcon />
                    </ToggleButton>
                    <ToggleButton value="masonry" aria-label="Masonry View">
                      <ViewQuiltIcon />
                    </ToggleButton>
                  </ToggleButtonGroup>
                </Box>
                {view === 'grid' ? (
                  <Grid container spacing={2}>
                    {Array.isArray(images) && images.map((img: any, idx: number) => {
                      return(
                        <Grid item xs={12} sm={6} md={4} lg={3} key={idx} className="gallery-grid-item">
                          <Box
                            component="img"
                            src={img?.url || ""}
                            alt={`gallery-img-${idx}`}
                            height={200}
                            sx={{ width: '100%', borderRadius: 2, objectFit: 'cover' }}
                            onClick={() => {
                              if(!promptMessageVisible){
                                setSelectedImageId && setSelectedImageId(img || null);
                                setUserProfileIcon?.(false);
                                onClose();
                              }
                            }}
                          />
                        </Grid>
                      )
                    })}
                  </Grid>
                ) : (
                  <Masonry breakpointCols={{ default: 5, 1100: 3, 700: 3, 500: 2, 400: 1 }}
                    className="my-masonry-grids"
                    columnClassName="my-masonry-grid_column"
                    style={{ width: '100%', height: "100%" }} >
                    {Array.isArray(images) && images.map((img: any, idx: number) => (
                      <Box
                        key={idx}
                        className="zoom-in"
                        component="img"
                        src={img?.url || ""}
                        alt={`gallery-img-${idx}`}
                        sx={{ width: '100%', display: 'block', borderRadius: 2, mb: 2, height: '100%', objectFit: 'cover' }}
                         onClick={() => {
                             if(!promptMessageVisible){
                              setSelectedImageId && setSelectedImageId(img || null);
                              setUserProfileIcon?.(false);
                            onClose();
                          }
                          }}
                      />
                    ))}
                  </Masonry>
                )}
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      )}

      {selectionMode === 'card' && (
        <DialogContent className="card-gallery-content">
          {models && models.filter(
            (model: any) => model?.training?.trainingRequestStatus === "COMPLETED" &&
              (selectedTypes.length === 0 || selectedTypes.includes(model?.type)) &&
              String(model?.type) !== 'Product'
          ).length > 0 ? (
            models
              .filter((model: any) => model?.training?.trainingRequestStatus === "COMPLETED" &&
                (selectedTypes.length === 0 || selectedTypes.includes(model?.type)) &&
                String(model?.type) !== 'Product')
              .map((model: any, index: number) => {
                const formattedDate = new Intl.DateTimeFormat('en-US', {
                  year: 'numeric',
                  month: 'short',
                  day: '2-digit',
                  timeZone: 'UTC',
                }).format(new Date(model.createdAt));
                return (
                  <Grid container xs={12} sm={6} md={6} lg={4} key={model._id || index}>
                    <Card className={ carToonpage ? "model-cards" : "model-card"}
                      onClick={() => {
                        console.log("model", model);
                        handleEventDetails(model || "")
                        setUserProfileIcon?.(false);
                      }}
                    >
                      <CardMedia
                        component="img"
                        height="300"
                        image={model?.url || model?.sampleImage?.url}
                        alt={model?.name}
                        sx={{
                          borderRadius: '10px 10px 0px 0px',
                          // objectFit: 'contain',
                        }}
                  
                      />
                      <CardContent className="modalCardContent">
                        <Box className="modelCardHeader">
                          <Avatar
                            className="avatarModel"
                            src={
                              model.sampleImage?.url ||
                              (model.type === "Person" ? '/assets/person_default.svg' : '/assets/product_default.svg')
                            }
                            alt={model.name}
                          />
                          <Typography component="div" className="modelCardTitle">
                            {model.name}
                          </Typography>
                        </Box>
                        <Grid item xs={12} container className={`${playingModelId !== model._id ? 'modelCardFooter' : 'modelCardFooters'}`}>
                          {playingModelId !== model._id && (
                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                            <Button className="type-button"
                          >{model?.type}</Button>
                          {model?.training !== null && model.training?.trainingRequestStatus !== "" &&
                            <Button
                              variant="contained"
                              color={model.status === 'Trained' ? 'success' : 'primary'}
                              className={`${model.training?.trainingRequestStatus === 'COMPLETED' ? 'trained-button' : 'type-button'}`}
                            >
                              {model.training?.trainingRequestStatus
                                .toLowerCase()
                                .replace(/^\w/, (c: string) => c.toUpperCase())}
                            </Button>}
                          </Box>
                          )}

                          {model?.training?.trainingRequestStatus === "COMPLETED" && model.voiceDetails?.previewAudioUrl && (
                            <IconButton
                              onClick={async (e) => {
                                e.stopPropagation();
                                if (playingModelId === model._id) {
                                  // Pause
                                  if (audioRef.current) {
                                    audioRef.current.pause();
                                  }
                                  setPlayingModelId(null);
                                } else if (model.voiceDetails?.previewAudioUrl) {
                                  // Play
                                  if (audioRef.current) {
                                    audioRef.current.pause();
                                  }
                                  audioRef.current = new Audio(model.voiceDetails.previewAudioUrl);
                                  audioRef.current.onended = () => setPlayingModelId(null);
                                  await audioRef.current.play();
                                  setPlayingModelId(model._id);
                                }
                              }}
                            >
                              {playingModelId === model._id ? (
                                <PauseCircleOutlineIcon className="playIconModelCard" />
                              ) : (
                                <PlayCircleOutlinedIcon className="playIconModelCard" />
                              )}
                            </IconButton>
                          )}
                            {/* Waveform animation */}
                            {playingModelId === model._id && (
                              <Box sx={{ display: 'flex', alignItems: 'center', height: 32, ml: 1 }}>
                                {waveformData.map((height, idx) => {
                                  // Pink for played, gray for rest
                                  const progressIdx = Math.floor(audioProgress * waveformData.length);
                                  const color = idx < progressIdx ? '#8b5cf6' : '#5a5f7e';
                                  return (
                                    <Box
                                      key={idx}
                                      sx={{
                                        width: 3,
                                        height: `${height}%`,
                                        backgroundColor: color,
                                        borderRadius: 1,
                                        mx: 0.2,
                                        transition: 'all 0.1s ease',
                                      }}
                                    />
                                  );
                                })}
                              </Box>
                            )}

                        </Grid>
                        <Typography variant="body2" className="modelCardDate">
                          Created On {formattedDate}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                )
              })
          ) : (
            <Box sx={{ textAlign: 'center', p: 2 }}>
              <p>No models available</p>
            </Box>
          )}
        </DialogContent>
      )}

    </Dialog>
  );
};

export default GalleyPopup;
